<template>
  <div ref="myEcharts" :style="{ height, width }"></div>
</template>
<script>
import { ref, onMounted } from "vue";
import * as echarts from "echarts";
export default {
  name: "baseBar",
  props: {
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "84%",
    },
    left2Data: {
      type: Object,
      default: () => {},
    }
  },
  setup(props) {
    // console.log(props);
    const myEcharts = ref(null);
    const chart = new InitChart(props, myEcharts);
    onMounted(() => {
      // console.log(props)
      chart.init(props.left2Data,props.name,props.color);
      
    });
    return {
      myEcharts,
    };
  },
};
class InitChart {
  constructor(props, myEcharts) {
    this.props = props;
    this.myEcharts = myEcharts;
    this.state = {
      chart: null,
    };
  }

  init() {
    this.state.chart && this.destory();
    this.state.chart = echarts.init(this.myEcharts.value);

let result = [
   { name: '1月', ai: 25, ai2: 50 },
   { name: '2月', ai: 50, ai2: 35 },
   { name: '3月', ai: 29, ai2: 25 },
   { name: '4月', ai: 26, ai2: 27 },
   { name: '5月', ai: 30, ai2: 34 },
   { name: '6月', ai: 70, ai2: 39 },
   { name: '7月', ai: 75, ai2: 28 },
   { name: '8月', ai: 26, ai2: 50 },
   { name: '9月', ai: 36, ai2: 26 },
   { name: '10月', ai: 62, ai2: 35 },
   { name: '11月', ai: 43, ai2: 86 },
   { name: '12月', ai: 75, ai2: 50 },
]

let xData = result.map((item) => {
   return item.name
})
let keys = ['ai', 'ai2'],
   seriesData = []
let color = ['0, 254, 210','73, 64, 171' ]
keys.forEach((key, index) => {
   seriesData.push({
      name: key + '数',
      data: result.map((item) => {
         return item[key]
      }),
      type: 'line',
      yAxisIndex: 0,
      symbol: 'none',
      symbolSize: 7,
      barWidth: 14,
      splitNumber: 6,
      smooth: false,
      itemStyle: {
         color: `rgba(${color[index]},1)`
      },
      lineStyle: {
         color: `rgba(${color[index]},1)`,
         width: 1
      },
      areaStyle: {
         opacity: 1,
         color: {
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            type: 'linear',
            global: false,
            colorStops: [
               {
                  offset: 0,
                  color: `rgba(${color[index]},0.8)`
               },
               {
                  offset: 0.8,
                  color: 'rgba(6, 8, 41,.1)'
               }
            ]
         },
         shadowColor: 'rgba(0, 0, 0, 0.1)',
         shadowBlur: 10
      }
   })
   seriesData.push({
      name: key + '数',
      data: [
         {
            coords: result.map((item) => {
               return [item.name, item[key]]
            })
         }
      ],
      type: 'lines',
      coordinateSystem: 'cartesian2d',
      zlevel: 1,
      polyline: true,
      smooth: true,
      symbol: 'circle',
      effect: {
         show: true,
         trailLength: 0.4,
         symbol: 'circle',
         period: 8,
         symbolSize: 4
      },
      lineStyle: {
         normal: {
            color: `rgba(${color[index]},1)`,
            width: 1,
            opacity: 0,
            curveness: 0
         }
      }
   })
})

    this.state.chart.setOption({
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'line'
        },
        backgroundColor: 'rgba(0, 0, 0,0.8)',
        borderColor: 'rgba(73, 64, 171, 0.5)',
        textStyle: {
          color: 'rgba(255, 255, 255, 1)'
        }
      },
   grid: {
      x: 50,
      y: 20,
      x2: 30,
      y2: 40
   },
   xAxis: {
      type: 'category',
      boundaryGap: false,
      data: xData,
      axisPointer: {
         handle: {
            show: false
         }
      },
      axisLine: {
         show: true,
         lineStyle: {
            color: '#5C6B79F'
         }
      },
      axisTick: {
         show: false
      },
      axisLabel: {
         fontSize: 12,
         interval: 'auto',
         
      }
   },
   yAxis: [
      {
         type: 'value',
         splitLine: {
            show: false
         },
         axisLabel: {
            fontSize: 12,
            interval: 'auto',
            color: '#A1A7B3',
         },
         axisLine: {
         show: true,
         lineStyle: {
            color: '#5C6B79'
         }
      },
      }
   ],
   series: seriesData
    });
    window.addEventListener("resize", () => {
      this.state.chart.resize();
    });
  }

  destory() {
    this.state.chart.dispose();
    window.removeEventListener("resize", () => {
      console.log("事件移除");
    });
  }
}
</script>
<style lang="less"></style>
